// Top-right stats: total clicker count, YOU/GOONS CPS, bonus m/click.
// Polled CPS uses two 5s rolling windows so the player sees their own pace
// separately from the goons working in the background.

import { Events, on } from './eventBus.js'
import { getClickCount } from '../game/seasonManager.js'
import { getYieldBonus } from '../game/buildingState.js'
import { formatCoinsDelta } from './format.js'

const FORMATTER = new Intl.NumberFormat('en-US')

export function mountStatsPanel({ root }) {
  const els = {
    clicks: root.querySelector('[data-clicks]'),
    youCps: root.querySelector('[data-you-cps]'),
    goonsCps: root.querySelector('[data-goons-cps]'),
    bonus: root.querySelector('[data-bonus]'),
  }

  const humanClicks = []
  const goonClicks = []
  on('paw:click', () => humanClicks.push(performance.now()))
  on(Events.GoonClick, () => goonClicks.push(performance.now()))
  setInterval(() => {
    const cutoff = performance.now() - 5000
    while (humanClicks.length && humanClicks[0] < cutoff) humanClicks.shift()
    while (goonClicks.length && goonClicks[0] < cutoff) goonClicks.shift()
    els.youCps.textContent = (humanClicks.length / 5).toFixed(1)
    els.goonsCps.textContent = (goonClicks.length / 5).toFixed(1)
  }, 250)

  on(Events.ClickCountChange, ({ clickCount }) => {
    els.clicks.textContent = FORMATTER.format(clickCount)
  })
  els.clicks.textContent = FORMATTER.format(getClickCount())

  const refreshBonus = () => {
    const bonus = getYieldBonus()
    els.bonus.textContent = bonus > 0 ? formatCoinsDelta(bonus) : '—'
  }
  on(Events.BuildingAdded, refreshBonus)
  refreshBonus()
}
